<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style>
/*  #app { min-width: 965px; }*/

  /*  @import "../static/css/main.css";
    @import "../static/css/color-dark.css";
    @import "../static/css/m-cover.css";*/
</style>



// WEBPACK FOOTER //
// App.vue?5cd8ec5a